import { render, staticRenderFns } from "./IssueReport.vue?vue&type=template&id=33116cb4"
import script from "./IssueReport.vue?vue&type=script&lang=js"
export * from "./IssueReport.vue?vue&type=script&lang=js"
import style0 from "./IssueReport.vue?vue&type=style&index=0&id=33116cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports